export default __webpack_public_path__ + "static/media/playstore.4f67fb4e.svg";